export const Divider = () => <div className="border-t border-secondary-20" />;
